"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FollowBlock = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Illustration = _interopRequireDefault(require("eventbrite_design_system/illustration/Illustration"));

var _FollowButton = _interopRequireDefault(require("./FollowButton"));

var _RandomSuperCrop = _interopRequireDefault(require("./RandomSuperCrop"));

var _dataPointPolicy = _interopRequireDefault(require("../utils/dataPointPolicy"));

var _constants = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ORGANIZER_IMAGE_DIAMETER_STANDARD = '80px';
var ORGANIZER_IMAGE_DIAMETER_MINI = '48px';

var OrganizerProfileImage = function OrganizerProfileImage(_ref) {
  var organizerId = _ref.organizerId,
      imageUrl = _ref.imageUrl,
      organizerName = _ref.organizerName,
      size = _ref.size;
  var organizerImage = null;
  var organizerImageSize = ORGANIZER_IMAGE_DIAMETER_STANDARD;

  if (size === _constants.MINI_SIZE) {
    organizerImageSize = ORGANIZER_IMAGE_DIAMETER_MINI;
  }

  if (imageUrl) {
    organizerImage = /*#__PURE__*/_react.default.createElement("img", {
      className: "organizer-card__image",
      src: imageUrl,
      width: organizerImageSize,
      height: organizerImageSize,
      alt: (0, _constants.organizerImageAltText)(organizerName)
    });
  } else {
    organizerImage = /*#__PURE__*/_react.default.createElement("div", {
      className: "organizer-card__image-placeholder"
    }, /*#__PURE__*/_react.default.createElement(_Illustration.default, {
      type: /*#__PURE__*/_react.default.createElement(_RandomSuperCrop.default, {
        id: organizerId
      }),
      width: organizerImageSize,
      height: organizerImageSize
    }));
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "organizer-card__image-container"
  }, organizerImage);
};

var getSubtitle = function getSubtitle(size, customDataPoint, numUpcomingEvents, numFollowers, shouldHideDefaultDataPoint) {
  if (!_dataPointPolicy.default.shouldShowDataPoint(customDataPoint, numUpcomingEvents, numFollowers, shouldHideDefaultDataPoint)) {
    return null;
  }

  var isStandardSize = size === _constants.STANDARD_SIZE;
  var isMiniSize = size === _constants.MINI_SIZE;
  var subtitleTextClasses = (0, _classnames.default)('organizer-card__subtitle', {
    'eds-text-bm': isStandardSize
  }, {
    'eds-text-bs': isMiniSize
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "organizer-card__subtitle-container"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: subtitleTextClasses
  }, _dataPointPolicy.default.getDataPointText(customDataPoint, numUpcomingEvents, numFollowers)));
};

var getButtonStyle = function getButtonStyle(isSolitary) {
  if (isSolitary) {
    return _constants.SOLITARY_BUTTON_STYLE;
  }

  return _constants.STANDARD_BUTTON_STYLE;
};

var getButtonSize = function getButtonSize(size) {
  if (size === _constants.STANDARD_SIZE) {
    return _constants.STANDARD_BUTTON_SIZE;
  }

  return _constants.COMPACT_BUTTON_SIZE;
};

var FollowBlock = function FollowBlock(_ref2) {
  var isFollowing = _ref2.isFollowing,
      organizerId = _ref2.organizerId,
      organizerName = _ref2.organizerName,
      organizerProfileUrl = _ref2.organizerProfileUrl,
      imageUrl = _ref2.imageUrl,
      numUpcomingEvents = _ref2.numUpcomingEvents,
      numFollowers = _ref2.numFollowers,
      customDataPoint = _ref2.customDataPoint,
      _ref2$onHandleOnClick = _ref2.onHandleOnClick,
      onHandleOnClick = _ref2$onHandleOnClick === void 0 ? function () {
    return {};
  } : _ref2$onHandleOnClick,
      shouldHideDefaultDataPoint = _ref2.shouldHideDefaultDataPoint,
      onFollow = _ref2.onFollow,
      onUnFollow = _ref2.onUnFollow,
      size = _ref2.size,
      isSolitary = _ref2.isSolitary,
      isFollowButtonDisabled = _ref2.isFollowButtonDisabled;
  var isStandardSize = size === _constants.STANDARD_SIZE;
  var isMiniSize = size === _constants.MINI_SIZE;
  var organizerCardTitleClasses = (0, _classnames.default)('organizer-card__title', {
    'eds-text-bl': isStandardSize
  }, {
    'eds-text-bm eds-text-weight--heavy': isMiniSize
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "organizer-card__block"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "organizer-card__image-and-text"
  }, /*#__PURE__*/_react.default.createElement("a", {
    onClick: onHandleOnClick,
    href: organizerProfileUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "organizer-card__link organizer-card__image-link",
    title: (0, _constants.viewOrganizerProfileString)(organizerName),
    tabIndex: "-1"
  }, /*#__PURE__*/_react.default.createElement(OrganizerProfileImage, {
    imageUrl: imageUrl,
    organizerName: organizerName,
    organizerId: organizerId,
    size: size
  })), /*#__PURE__*/_react.default.createElement("a", {
    onClick: onHandleOnClick,
    href: organizerProfileUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "organizer-card__link organizer-card__title-link",
    title: (0, _constants.viewOrganizerProfileString)(organizerName)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "organizer-card__title-container"
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: organizerCardTitleClasses
  }, organizerName)), getSubtitle(size, customDataPoint, numUpcomingEvents, numFollowers, shouldHideDefaultDataPoint))), /*#__PURE__*/_react.default.createElement(_FollowButton.default, {
    __containerClassName: "organizer-card__cta",
    isFollowing: isFollowing,
    onFollow: onFollow,
    onUnFollow: onUnFollow,
    organizerName: organizerName,
    style: getButtonStyle(isSolitary),
    size: getButtonSize(size),
    isDisabled: isFollowButtonDisabled
  }));
};

exports.FollowBlock = FollowBlock;
FollowBlock.propTypes = {
  isFollowing: _propTypes.default.bool,
  organizerId: _propTypes.default.string.isRequired,
  organizerName: _propTypes.default.string.isRequired,
  organizerProfileUrl: _propTypes.default.string.isRequired,
  onFollow: _propTypes.default.func.isRequired,
  onUnFollow: _propTypes.default.func.isRequired,
  size: _propTypes.default.oneOf(_constants.CARD_SIZES).isRequired,
  imageUrl: _propTypes.default.string,
  numUpcomingEvents: _propTypes.default.number,
  numFollowers: _propTypes.default.number,
  customDataPoint: _propTypes.default.string,
  shouldHideDefaultDataPoint: _propTypes.default.bool,
  onHandleOnClick: _propTypes.default.func,
  isSolitary: _propTypes.default.bool
};
var _default = FollowBlock;
exports.default = _default;
//# sourceMappingURL=FollowBlock.js.map